module.exports = __webpack_public_path__ + "static/img/15.3268235.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/15.png
// module id = eAMm
// module chunks = 0